import * as React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { SelectOption, selectOptionLabelToPlainString } from './base-input.component';
import i18n from '../../i18n';
import { CircularProgress } from '@mui/material';


export default function SelectInputAutocompleteAsync({ fetchData, value, onChange, ...otherProps }: SelectInputAutocompleteAsyncProps) {
    const [options, setOptions] = React.useState<readonly SelectOption[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [inputValue, setInputValue] = React.useState('');

    React.useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }
        (async () => {
            setLoading(true)
            const dataOptions = await fetchData?.(inputValue);
            setLoading(false)
            if (active) {
                setOptions(dataOptions ? [...dataOptions] : []);
            }
        })();

        return () => {
            active = false;
        };
    }, [value, inputValue, fetchData]);

    return (
        <Autocomplete
            noOptionsText={i18n.t('general_text_no_data')}
            value={value || null}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            getOptionLabel={(option) => selectOptionLabelToPlainString(option.label)}
            options={options}
            loading={loading}
            onChange={(_event, newValue: SelectOption | null) => {
                onChange?.(newValue)
            }}
            onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...otherProps}
                    size='small'
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
}

export type SelectInputAutocompleteAsyncProps = {
    fetchData?: (label?: string) => Promise<SelectOption[]>;
    value?: SelectOption | null;
    onChange?: (value: SelectOption | null) => void;
} & TextFieldProps

